import React from "react"
import { useStaticQuery, graphql } from "gatsby"

enum SanityTextBlock {
  Headline = "h3",
  Normal = "normal",
}

interface Programme {
  sanityProgramme: {
    programmeHeadline: string
    programmeText: [
      {
        children: [
          {
            text: string
          }
        ]
        style: SanityTextBlock
      }
    ]
  }
}

export default () => {
  const { sanityProgramme }: Programme = useStaticQuery(graphql`
    query {
      sanityProgramme {
        programmeHeadline
        programmeText {
          children {
            text
          }
          style
        }
      }
    }
  `)

  const { programmeHeadline, programmeText } = sanityProgramme

  return (
    <section className="programme-wrapper">
      <h2>{programmeHeadline}</h2>

      <div className="programme">
        {programmeText.map((textBlock, index) => {
          const { style, children } = textBlock
          if (!children) return

          const [textObject] = children
          const { text } = textObject

          if (!text) return

          const isHeadline = style === SanityTextBlock.Headline
          return (
            <React.Fragment key={`programme-text-${index}`}>
              {isHeadline ? <h3>{text}</h3> : <p>{text}</p>}
            </React.Fragment>
          )
        })}
      </div>
    </section>
  )
}
